import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import NavigationStore from './Navigation.store'
import UserProfileService from './../../shared/services/UserProfile.service'
import { MDBSideNavMenu, MDBIcon, MDBSideNavLink, MDBSideNavCollapse } from 'mdb-react-ui-kit'
import { canAccessLink } from './../../shared/utilities/linkAccessFilter.function'
import CryptoJS from 'crypto-js'
import './AdminNavLinks.scss'

const AdminNavLinks = ({ goTo }) => {
  const [expandedMenu, setExpandedMenu] = useState(null)
  const [isBuilt, setIsBuilt] = React.useState(false)

  React.useEffect(() => {
    if (!isBuilt) {
      NavigationStore.build()
      setIsBuilt(true)
    }
  }, [isBuilt])

  const toggleMenu = menuId => {
    setExpandedMenu(expandedMenu === menuId ? null : menuId)
  }

  const renderLink = (link, idx) => {
    const url = link?.url
      ? /^(http:|https:)/.test(link.url)
        ? link.url
        : link.url
            .replace(':userId', UserProfileService.get('u_login'))
            .replace(
              ':recruiterId',
              CryptoJS.AES.encrypt(UserProfileService.getUserId(true).toString(), 'usabg').toString()
            )
      : ''

    if (url) {
      return (
        <li key={`i-a-${idx}`} className={'Ripple-parent ' + (!canAccessLink(link) ? 'is-hidden-link' : '')}>
          <a
            target='_BLANK'
            rel='noopener noreferrer'
            href={url}
            className='Ripple-parent'
            onClick={event => {
              event.preventDefault()
              goTo(url)
              return false
            }}
          >
            {link.label}
            <MDBIcon icon='lock' />
          </a>
        </li>
      )
    }
  }

  const renderNavLinks = link => {
    const menuId = link?.label ? link.label.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase() : 'void'
    const isExpanded = expandedMenu === menuId

    return (
      <div key={`${link?.label}`} className='nav-menu-container'>
        <MDBSideNavLink
          id={`nav-opt---${menuId}`}
          name={link?.label}
          icon='angle-down'
          onClick={() => toggleMenu(menuId)}
          shouldBeExpanded={isExpanded}
          className='nav-menu-header'
        >
          {link?.icon && <MDBIcon icon={link.icon} className='admin-lock-icon' />}
          {link?.label}
        </MDBSideNavLink>
        <MDBSideNavCollapse open={isExpanded}>
          <MDBSideNavMenu>
            <ul className='nav-menu-items'>{(Array.isArray(link?.children) ? link.children : []).map(renderLink)}</ul>
          </MDBSideNavMenu>
        </MDBSideNavCollapse>
      </div>
    )
  }

  if (!isBuilt) {
    return (
      <div className='admin-nav-links'>
        <ul id='AdminNavLinksComponent'>
          <div className='nav-menu-container'></div>
        </ul>
      </div>
    )
  }

  return (
    <div className='admin-nav-links'>
      <ul id='AdminNavLinksComponent'>
        <div className='nav-menu-container'></div>
        {NavigationStore.minor.map(link => renderNavLinks(link))}
      </ul>
    </div>
  )
}

export default observer(AdminNavLinks)
